import { FC, useMemo } from 'react';
import { Layer, Source } from 'react-map-gl';

interface QuarterGridLayerProps {
  /** Grid points as `[lon, lat]`. */
  points: GeoJSON.Position[];
}

/**
 * The quarter-grid dots — corners of each survey tract's quartered squares.
 *
 * The same points dragged vertices snap to, so the operator can see what they
 * will land on. Non-interactive: a click here must reach the unit beneath.
 *
 * @param {QuarterGridLayerProps} props - The grid points.
 * @return {JSX.Element | null} The layer, or null when there is nothing to draw.
 */
export const QuarterGridLayer: FC<QuarterGridLayerProps> = ({ points }) => {
  const data = useMemo<GeoJSON.FeatureCollection>(
    () => ({
      type: 'FeatureCollection',
      features: points.map((position) => ({
        type: 'Feature',
        properties: {},
        geometry: { type: 'Point', coordinates: position },
      })),
    }),
    [points]
  );

  if (points.length === 0) return null;

  return (
    <Source id="unit-builder-quarter-grid" type="geojson" data={data}>
      <Layer
        id="unit-builder-quarter-grid-dots"
        type="circle"
        paint={{
          'circle-radius': 2.5,
          'circle-color': '#6929c4',
          'circle-opacity': 0.8,
          'circle-stroke-width': 1,
          'circle-stroke-color': '#6929c4',
          'circle-stroke-opacity': 0.8,
        }}
      />
    </Source>
  );
};
